import { Persona } from '@/shared/model/persona/persona.model';
import { AreaConocimiento } from './area-conocimiento.model';
import { Coordinador } from './coordinador.model';
import { Institucion } from './institucion.model';
import { PlanEstudio } from './plan-estudio.model';
import { Sede } from './sede.model';

export interface IPrograma {
  clave?: string | null;
  nombre?: string | null;
  cveGrado?: string | null;
  grado?: string | null;
  tipo?: string | null;
  periodoLectivo?: number | null;
  duracionOficial?: number | null;
  totalPeriodosLectivo?: number | null;
  fechaTerminoVigencia?: string | null;
  caracteristica?: string | null;
  orientacion?: string | null;
  modalidad?: string | null;
  categoria?: string | null;
  estatus?: string | null;
  tipoEspecial?: string | null;
  areasConocimiento?: AreaConocimiento[] | null;
  institucion?: Institucion | null;
  sede?: Sede | null;
  planDeEstudios?: PlanEstudio;
  coordinadores?: Coordinador[];
  coordinadorVigente?: Persona;
  cveCaracteristica?: string | null;
}

export class Programa implements IPrograma {
  constructor(
    public clave?: string | null,
    public nombre?: string | null,
    public cveGrado?: string | null,
    public grado?: string | null,
    public tipo?: string | null,
    public periodoLectivo?: number | null,
    public duracionOficial?: number | null,
    public totalPeriodosLectivo?: number | null,
    public fechaTerminoVigencia?: string | null,
    public caracteristica?: string | null,
    public orientacion?: string | null,
    public modalidad?: string | null,
    public categoria?: string | null,
    public estatus?: string | null,
    public tipoEspecial?: string | null,
    public areasConocimiento?: AreaConocimiento[] | null,
    public institucion?: Institucion | null,
    public sede?: Sede,
    public planDeEstudios?: PlanEstudio,
    public coordinadores?: Coordinador[],
    public coordinadorVigente?: Persona,
    public cveCaracteristica?: string | null
  ) {
    this.institucion = this.institucion ? this.institucion : new Institucion();
    this.sede = this.sede ? this.sede : new Sede();
    this.areasConocimiento = this.areasConocimiento ? this.areasConocimiento : [];
    this.planDeEstudios = this.planDeEstudios ? this.planDeEstudios : new PlanEstudio();
    this.coordinadores = this.coordinadores ? this.coordinadores : [];
    this.coordinadorVigente = this.coordinadorVigente ? this.coordinadorVigente : new Persona();
  }
}
